module.exports = __webpack_public_path__ + "static/media/gmn_homepage.263f3fe6.png";